import React from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import "./tooltip.scss"

interface TooltipProps {
	indexValue: string | number
	data: Record<string, any>
	color: string
}

const Tooltip: React.FC<TooltipProps> = ({ indexValue, data, color }) => (
	<div className="chart-tooltip">
		<div className="color" style={{ background: color }} />
		<div>
			<strong>{indexValue}</strong>
			<br />
			<FormattedMessage
				id="phronesis.customerbehavior.application.customerProfiling.tooltip.clients"
				values={{
					amount: <FormattedNumber value={data?.customers} style="decimal" />,
				}}
			/>
			<br />
			<FormattedMessage
				id="phronesis.customerbehavior.application.customerProfiling.tooltip.variation"
				values={{
					variation: (
						<FormattedNumber
							value={data?.variation}
							style="percent"
							minimumFractionDigits={1}
						/>
					),
				}}
			/>
		</div>
	</div>
)

export default Tooltip
